import React from 'react'

function MS_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp p-5'>
                    <div className='mt-5'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>10,000+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Shreya Shashikant Panmand</h5>
                    <h6 class="font-weight-bold my-2">Modern college of Pune BBACA</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Great experience of this class such amazing class teacher an all they help to students to grow up I am thankful to Internselite.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Sahil Gupta</h5>
                    <h6 class="font-weight-bold my-2">Chandigarh Engineering College, Mohali, (B.tech in Information Technology)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I recently completed the web development course at Internselite and I am extremely happy with the results. I learned everything I need to know to start building my own websites, from HTML and CSS to JavaScript. The instructor was knowledgeable and engaging, and he made sure that everyone in the class understood the concepts. I would highly recommend this course to anyone who is interested in learning web development.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">P. Madhavi</h5>
                    <h6 class="font-weight-bold my-2">Sri Krishna Devaraya University, B.tech(CSE)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>   In this internship they provided content is well structured and time management and time table is very well structured. Over all it is like a game changer to me, finally it's been fantastic.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Priya Arya</h5>
                    <h6 class="font-weight-bold my-2">Guru Nanak Dev University, Regional Campus Gurdaspur, (CSE)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was a nice journey, I learnt so well and the efforts of the teachers are inestimable
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Mohd Aaquid Faisal Shaikh A Rasheed </h5>
                    <h6 class="font-weight-bold my-2">Dr D Y Patil College of Engineering and Innovation Varale Pune, Computer Engineering </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was a great Training,Thank you so much for an amazing course, I learned so much and you made even the more complex topics interesting and easier to follow through real world stories and case studies. The course and all the materials are both comprehensive and informative.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Vivek Chaturvedi</h5>
                    <h6 class="font-weight-bold my-2">CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Impressed by Internslite's Full Stack Developer's exemplary skills in front-end and back-end technologies, including JavaScript, React, and Node.js. Their seamless interface creation, problem-solving, and collaborative approach made the internship enriching. Highly recommend their top-notch expertise in web development.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default MS_Review_Program_Page
